(function () {
  const EMAIL_FIELD_NAME = 'EMAIL';
  const RESTRICTED_DOMAINS = ['gmail.com', 'yahoo.com', 'yandex.com', 'mac.com', 'yandex.ru', 'hotmail.com', 'me.com', 'fb.com', 'facebook.com', 'outlook.com', 'msn.com'];
  let $resultsForm = $('form[data-results-form]');

  validate.validators.notRestrictedEmailDomain = function (value) {
    let [, domain] = value.split('@');
    return RESTRICTED_DOMAINS.includes(domain) ? `^Please enter your business email` : null;
  };

  $resultsForm.submit(function (event) {
    event.preventDefault();
    let $this = $(this);
    let values = getFormMistakesValues($this);
    let errorMessage = validateMistakesEmail(values[EMAIL_FIELD_NAME]);

    if (errorMessage) {
      showError($this, errorMessage);
      return false;
    } else {
      hideErrors($this);
    }

    let url = $this.attr('action');
    let method = $this.attr('method');
    fetch(url, {
      method: method,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
      },
      mode: "no-cors",
      body: $this.serialize()
    }).then(() => {
      closeMistakesFormSuccess();
    }).catch(error => {
      console.error(error);
      alert('Something went wrong.Please try again!');
      window.location.reload();
    });
  });

  function validateMistakesEmail(email) {
    let constraints = {
      email: {
        presence: {
          allowEmpty: false,
          message: "Please fill in"
        },
        email: {
          message: "Hmm…that email doesn't look valid"
        },
        notRestrictedEmailDomain: {
          message: 'sd'
        }
      }
    };
    let errors = validate({
      email
    }, constraints);
    return errors && errors.email.length ? errors.email[0] : '';
  }

  function showError(form, message) {
    let emailInput = form.find(`input[name="${EMAIL_FIELD_NAME}"]`);
    emailInput
      .closest('.mailchimp-form__input-wrapper')
      .addClass('has-errors')
      .find('.mailchimp-form__error-message')
      .text(message);
  }

  function hideErrors(form) {
    let emailInput = form.find(`input[name="${EMAIL_FIELD_NAME}"]`);
    emailInput
      .closest('.mailchimp-form__input-wrapper')
      .removeClass('has-errors')
      .find('.mailchimp-form__error-message')
      .text('');
  }

  function getFormMistakesValues(values) {
    return values.serializeArray().reduce((acc, item) => {
      if (!acc[item.name]) {
        acc[item.name] = item.value !== '' ? item.value : null;
      } else {
          acc[item.name] += ", " + item.value;
        }

      return acc;
    }, {});
  }

  function closeMistakesFormSuccess() {
      window.open("https://cdn.shopify.com/s/files/1/0260/4322/0045/files/Lotus_Themes._Organizing_Your_Help_Center._Survey_Results.pdf", "_blank");
      setTimeout(function () {
        $resultsForm.hide();
        $(".mailchimp-form__message").removeClass("hide");
      }, 1000);
    }
})();

$('.mailchimp-form__input').on('input invalid', function () {
  this.setCustomValidity('');

  if (this.validity.valueMissing) {
    this.setCustomValidity("Email can't be blank");
  }

  if (this.validity.typeMismatch) {
    this.setCustomValidity("Hmm…that email doesn't look valid");
  }
});